import { TemplateRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { ProductListDetailComponent } from '../product-list-detail/product-list-detail.component';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var ProductListComponent = (function () {
    function ProductListComponent(apiService, translate, authService, modalService) {
        this.apiService = apiService;
        this.translate = translate;
        this.authService = authService;
        this.modalService = modalService;
        this.itemsPerPage = 40;
        this.modal = null;
        this.modalData = null;
        this.searchProductID = '';
        this.searchProductName = '';
        this.groups = [];
        this.currentPage = 1;
        this.loading = false;
        this.list = [];
        this.selectedValues = [];
        this.allChecked = false;
        this.productDetails = [];
    }
    ProductListComponent.prototype.ngOnInit = function () {
        this.subs = this.translate.onLangChange.subscribe(function (res) {
        });
        this.pageChanged();
    };
    ProductListComponent.prototype.reload = function () {
        this.pageChanged();
    };
    ProductListComponent.prototype.pageChanged = function () {
        this.loadData();
    };
    ProductListComponent.prototype.optionChanged = function () {
        this.search();
    };
    ProductListComponent.prototype.openModal = function (data, index) {
        this.detailModal.open(this, data);
    };
    ProductListComponent.prototype.search = function () {
        this.currentPage = 1;
        this.loadData();
    };
    ProductListComponent.prototype.loadData = function () {
        var _this = this;
        this.loading = true;
        var data = {
            page: this.currentPage,
            items_per_page: this.itemsPerPage,
            product_id: this.searchProductID,
            name_en: this.searchProductName
        };
        this.apiService.getProducts(data)
            .pipe(finalize(function () {
            _this.loading = false;
        }))
            .subscribe(function (res) {
            _this.productDetails = res.results;
            if (res) {
                _this.totalItems = res.count;
                _this.selectedValues = Array(_this.productDetails.length).fill(false);
            }
        });
    };
    ProductListComponent.prototype.confirmDelete = function (index) {
        this.modalData = this.productDetails[index];
        this.modal = this.modalService.open(this.deleteConfirmationModal, { backdrop: 'static', centered: true });
    };
    ProductListComponent.prototype.confirmedDelete = function (productId) {
        var _this = this;
        this.apiService.deleteProduct(productId).subscribe(function () {
            _this.loadData();
            _this.sniff('DELETE_PRODUCT', _this.modalData.product_id + ';' + _this.modalData.name_en);
            _this.revertBack();
        });
    };
    ProductListComponent.prototype.clearSearch = function () {
        this.searchProductID = '';
        this.searchProductName = '';
        this.loadData();
    };
    ProductListComponent.prototype.revertBack = function () {
        this.modal.close();
        this.modal = null;
        this.modalData = null;
    };
    ProductListComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'MANAGE_PRODUCT',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    ProductListComponent.prototype.selectDeselectAll = function (checked) {
        this.selectedValues = Array(this.productDetails.length).fill(checked);
        this.allChecked = checked;
    };
    ProductListComponent.prototype.getSelectId = function () {
        var selectedId = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (this.selectedValues[i]) {
                selectedId.push(this.productDetails[i].id);
            }
        }
        return selectedId.join(',');
    };
    ProductListComponent.prototype.getExportExcel = function () {
        var _this = this;
        var params = {
            search_box: this.getSelectId(),
        };
        this.apiService.getProductExcel(params).subscribe(function (obj) {
            var currentDate = moment().format('DD-MM-YYYY');
            var filename = currentDate + "_product_export.xlsx";
            _this.sniff('DOWNLOAD_XLS', filename);
            _this.apiService.createDownloadFile(obj, filename);
        });
    };
    ProductListComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    Object.defineProperty(ProductListComponent.prototype, "isAdmin", {
        get: function () {
            return this.authService.isAdmin();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductListComponent.prototype, "isIT", {
        get: function () {
            return this.authService.isIT();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductListComponent.prototype, "isAccountant", {
        get: function () {
            return this.authService.isAccountant();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductListComponent.prototype, "isAccountantAdmin", {
        get: function () {
            return this.authService.isAccountantAdmin();
        },
        enumerable: true,
        configurable: true
    });
    return ProductListComponent;
}());
export { ProductListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list/product-list.component.ts.pre-build-optimizer.js